export default "__VITE_ASSET__51699e8a__"